(() => {
  const init = (root) => {
    if (root.dataset.communityReady) return;
    root.dataset.communityReady = 'true';
    const viewport = root.querySelector('[data-community-window]');
    const cards = [...root.querySelectorAll('.p-community-card')];
    const pause = root.querySelector('[data-community-pause]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!cards.length) return;
    let paused = reduced.matches || Boolean(window.Shopify?.designMode);
    let hovered = false;
    let focused = false;
    let visible = false;
    let dragStart = null;
    let timer;
    const stride = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : viewport.clientWidth;
    const index = () => Math.min(cards.length - 1, Math.round(viewport.scrollLeft / stride()));
    const update = () => { root.querySelector('[data-community-count]').textContent = `${String(index() + 1).padStart(2, '0')} / ${cards.length}`; };
    const setPause = () => {
      pause.setAttribute('aria-label', paused ? 'Play image carousel' : 'Pause image carousel');
      root.querySelector('[data-community-pause-label]').textContent = paused ? 'Play' : 'Pause';
      root.querySelector('[data-community-pause-icon]').textContent = paused ? '▷' : 'Ⅱ';
    };
    const move = (direction, manual = false) => {
      const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      let left = viewport.scrollLeft + direction * stride();
      if (direction > 0 && viewport.scrollLeft >= max - 4) left = 0;
      if (direction < 0 && viewport.scrollLeft <= 4) left = max;
      viewport.scrollTo({left: Math.max(0, Math.min(max, left)), behavior: reduced.matches ? 'instant' : 'smooth'});
      if (manual) { paused = true; setPause(); }
    };
    root.querySelector('[data-community-prev]').addEventListener('click', () => move(-1, true));
    root.querySelector('[data-community-next]').addEventListener('click', () => move(1, true));
    pause.addEventListener('click', () => { paused = !paused; setPause(); });
    viewport.addEventListener('mouseenter', () => { hovered = true; });
    viewport.addEventListener('mouseleave', () => { hovered = false; });
    viewport.addEventListener('focusin', () => { focused = true; });
    viewport.addEventListener('focusout', () => { focused = false; });
    viewport.addEventListener('pointerdown', event => {
      paused = true; setPause();
      if (event.pointerType === 'mouse') {
        event.preventDefault();
        dragStart = {x:event.clientX,y:event.clientY};
        viewport.setPointerCapture(event.pointerId);
      }
    });
    viewport.addEventListener('pointerup', event => {
      if (!dragStart) return;
      const dx = event.clientX - dragStart.x;
      const dy = event.clientY - dragStart.y;
      dragStart = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) move(dx < 0 ? 1 : -1, true);
    });
    viewport.addEventListener('pointercancel', () => { dragStart = null; });
    viewport.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1, true);
      }
    });
    viewport.addEventListener('scroll', update, {passive:true});
    viewport.addEventListener('scrollend', () => {
      if (paused) root.querySelector('[data-community-status]').textContent = `Image ${index() + 1} of ${cards.length}`;
    });
    reduced.addEventListener('change', event => { if (event.matches) { paused = true; setPause(); } });
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, {threshold:0.15});
    observer.observe(root);
    timer = window.setInterval(() => {
      if (!root.isConnected) { window.clearInterval(timer); observer.disconnect(); return; }
      if (visible && !paused && !hovered && !focused && !document.hidden) move(1);
    }, 5000);
    setPause(); update();
  };
  document.querySelectorAll('[data-prime-community]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-prime-community]').forEach(init));
})();
